export const CATEGORIES = [
  { id: 'oshi', label: '推し活', emoji: '✨' },
  { id: 'kpop', label: 'K-POP', emoji: '🎤' },
  { id: 'anime', label: 'アニメ', emoji: '🎬' },
  { id: 'game', label: 'ゲーム', emoji: '🎮' },
  { id: 'language', label: '語学', emoji: '🌐' },
  { id: 'study', label: '勉強', emoji: '📚' },
  { id: 'music', label: '音楽', emoji: '🎵' },
  { id: 'fashion', label: 'ファッション', emoji: '👗' },
  { id: 'beauty', label: '美容', emoji: '💄' },
  { id: 'photo', label: 'カメラ', emoji: '📷' },
  { id: 'food', label: '料理', emoji: '🍳' },
  { id: 'pet', label: 'ペット', emoji: '🐾' },
  { id: 'sports', label: 'スポーツ', emoji: '⚽' },
  { id: 'travel', label: '旅行', emoji: '✈️' },
  { id: 'book', label: '読書', emoji: '📖' },
  { id: 'tech', label: 'プログラミング', emoji: '💻' },
  { id: 'other', label: 'その他', emoji: '🏷️' },
];

export function getCategory(id) {
  return CATEGORIES.find((c) => c.id === id) || null;
}
